import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=e51cf596&scoped=true"
import script from "./ChatLayout.vue?vue&type=script&lang=ts"
export * from "./ChatLayout.vue?vue&type=script&lang=ts"
import style0 from "./ChatLayout.vue?vue&type=style&index=0&id=e51cf596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51cf596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
